module.exports = __webpack_public_path__ + "static/media/47.6dbdeee3.jpg";